
import { throwError as observableThrowError, Observable } from 'rxjs';

import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';


import { ServiceBase } from '@app/services/base.service';
import { EstadoDoProcesso } from '@app/models/estado-do-processo.model';

@Injectable()
export class EstadoDoProcessoService extends ServiceBase {
  constructor(private http: HttpClient) {
    super();
  }
  gravar(estadoDoProcesso: EstadoDoProcesso): Observable<any> {
    return this.http
      .post<any>(this.URL_API + 'configuracoes/estadoDoProcesso', estadoDoProcesso).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  deletar(id: number): Observable<any> {
    return this.http
      .delete<any>(this.URL_API + `configuracoes/estadoDoProcesso/${id}`).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  obterPorId(id: number): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `configuracoes/estadoDoProcesso/${id}`);
  }

  obterPesquisa(descricao: string, pagina: number): Observable<any> {
    descricao = encodeURIComponent(descricao);
    return this.http
      .get<any>(this.URL_API + `configuracoes/estadoDoProcesso/lista/?descricao=${descricao}&pagina=${pagina}`, { headers: { meta: ['search'] }});
  }

  // obterTodos() {
  //   return this.http.get(this.URL_API + "configuracoes/estadoDoProcesso/")
  //     .map((res: Response) => res.json());
  // }

}
